import { countDownCalculations, dateCheck } from '@/shared/utils'
import { useEffect, useState } from 'react'

type TimerType = {
	years?: number | string
	days: number | string
	hours: number | string
	min: number | string
	sec: number | string
	millisec?: number | string
}

const useTimer = (date: string | number) => {
	const [timer, setTimer] = useState<TimerType>({
		days: '00',
		hours: '00',
		min: '00',
		sec: '00',
	})
	useEffect(() => {
		if (!date) {
			return;
		  }
		const intervalId = setInterval(
			() => {
				const startDate = countDownCalculations(dateCheck(date)) as TimerType
				startDate && setTimer(startDate)
			},
			0,
			1000
		)
		return () => {
			clearInterval(intervalId)
		}
	}, [date])

	return {
		timer,
	}
}

export default useTimer
